// ** Icons Import
import { Layers, Circle, Settings } from 'react-feather'

export default [
  {
    header: 'Daily Log'
  },
  {
    id: 'dailyLog',
    title: 'Daily Log',
    icon: <Layers size={20} />,
    children: [
      {
        id: 'dayStart',
        title: 'Day Start',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/dayStart'
      },
      {
        id: 'productDensity',
        title: 'Product Density',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/productDensity'
      },
      {
        id: 'purchaseFuel',
        title: 'Purchase Fuel',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/purchaseFuel'
      },
      {
        id: 'purchaseOil',
        title: 'Purchase Oil',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/purchaseOil'
      },
      {
        id: 'dsmApproval',
        title: 'DSM Approval',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/dsmApproval'
      },
      {
        id: 'nozzelGrid',
        title: 'Nozzel Grid',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/nozzelGrid'
      },
      {
        id: 'variationDaily',
        title: 'Variation',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/variation'
      },
      {
        id: 'oilSale',
        title: 'Oil Sale',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/oilSale'
      },
      {
        id: 'petroCard',
        title: 'Petro Card',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/petroCard'
      },
      {
        id: 'swipeCard',
        title: 'Swipe Card',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/swipeCard'
      },
      {
        id: 'banking',
        title: 'Banking',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/banking'
      },

      {
        id: 'creditClient',
        title: 'Credit Client',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/creditClient'
      },
      {
        id: 'receipt',
        title: 'Receipt',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/receipt'
      },
      {
        id: 'handLoans',
        title: 'Hand Loans',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/handLoans'
      },
      {
        id: 'advances',
        title: 'Advances',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/advances'
      },
      {
        id: 'payment',
        title: 'Payment',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/payment'
      },
      {
        id: 'expenses',
        title: 'Expenses',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/expenses'
      },
      // {
      //   id: 'staffSale',
      //   title: 'Staff Sale',
      //   icon: <Circle size={12} />,
      //   navLink: '/dailyLog/staffSale'
      // },
      
      // {
      //   id: 'dayProfit',
      //   title: 'Day Profit',
      //   icon: <Circle size={12} />,
      //   navLink: '/dailyLog/dayProfit'
      // },
      {
        id: 'stockBook',
        title: 'Stock Book',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/stockBook'
      },
      {
        id: 'dayBook',
        title: 'Day Book',
        icon: <Circle size={12} />,
        navLink: '/dailyLog/dayBook'
      }
      // {
      //   id: 'daySummary',
      //   title: 'Day Summary',
      //   icon: <Circle size={12} />,
      //   navLink: '/dailyLog/daySummary'
      // }
    ]
  }
]
